<template>
  <div id="myData" class="widget" :class="{active: isActive()}">
    <div class="hr">
        <span>{{ $t('data.headline') }}</span>
    </div>

    <div v-if="!modus">
      <ul class="dataListing">
        <li>
          <div class="field">{{ $t('data.name') }}</div>
          <div class="value">{{$auth.user().agilea.lastName}}, {{$auth.user().agilea.firstName}}</div>
        </li>
        <li>
          <div class="field">{{ $t('data.memberId') }}</div>
          <div class="value">{{$auth.user().agilea.id}}</div>
        </li>
        <li>
          <div class="field">{{ $t('data.birthday') }}</div>
          <div class="value">{{birthday}}</div>
        </li>
        <li>
          <div class="field">{{ $t('data.email') }}</div>
          <div class="value">{{$auth.user().agilea.email}}</div>
        </li>
        <li>
          <div class="field">{{ $t('data.address') }}</div>
          <div class="value">{{$auth.user().agilea.street}}, {{$auth.user().agilea.zip}}, {{$auth.user().agilea.city}}</div>
        </li>
        <li>
          <div class="field">{{ $t('data.password') }}</div>
          <div class="value">****************</div>
        </li>
        <li>
          <div class="field">{{ $t('common.communicationLanguage') }}</div>
          <div class="value text-uppercase">{{ $auth.user().agilea.language }}</div>
        </li>
      </ul>
    </div>
    <home-my-data-password v-if="modus=='password'" @close="setModus(false)"></home-my-data-password>
    <home-my-data-update v-if="modus=='update'" @close="setModus(false)"></home-my-data-update>
    <home-my-data-language v-if="modus=='language'" @close="setModus(false)"></home-my-data-language>

    <div class="menu mt-3" v-if="!modus">
      <span @click="setModus('update')">{{ $t('data.changeAddress') }}</span>
      <span @click="setModus('password')">{{ $t('data.changePassword') }}</span>
      <span @click="setModus('language')">{{ $t('data.changeLanguage') }}</span>
    </div>
  </div>
</template>

<script>
import 'moment/locale/de';
import moment from "moment";

import HomeMyDataUpdate from "@/components/HomeMyDataUpdate";
import HomeMyDataPassword from "@/components/HomeMyDataPassword";
import HomeMyDataLanguage from "@/components/HomeMyDataLanguage";

export default {
  name: "HomeMyData.vue",
  components: {
    HomeMyDataPassword, HomeMyDataUpdate, HomeMyDataLanguage
  },
  data(){
    return {
        modus: false,
    }
  },
  computed:{
    birthday(){
      if(!this.$auth) { return null; }

      return moment(this.$auth.user().agilea.birthday).format('DD.MM.YYYY');
    }
  },
  methods:{
    setModus(modus){
      this.modus = modus;
    },
    isActive(){
      return this.modus != false;
    }
  }
}
</script>

<style scoped>

</style>